/**
 * Insets the IntersectionObserver root only on the bottom. A uniform
 * negative margin (e.g. -100px on all sides) excludes the top 100px of the
 * viewport, so first-screen content often never "intersects" and stays hidden
 * in Safari — especially after client-side route changes.
 */
export const WHILE_IN_VIEW_ROOT_MARGIN = '0px 0px -100px 0px' as const;
